export function runtimePublicPath(path:string):string{
  if(/^(?:https?:|data:|blob:)/i.test(path))return path
  const normalized=path.startsWith('/')?path:`/${path}`
  if(normalized==='/fight'||normalized.startsWith('/fight/'))return normalized
  if(typeof window==='undefined')return normalized
  const mounted=window.location.pathname==='/fight'||window.location.pathname.startsWith('/fight/')
  return mounted?`/fight${normalized}`:normalized
}
